import { makeStyles } from '@focaldata/cin-ui-components'

interface StyleProps {
  width?: string | number
}

const useStyles = makeStyles<{ styleProps?: StyleProps }>()(
  (theme, { styleProps: props }) => ({
    container: {
      maxWidth: props?.width,
      height: theme.spacing(6)
    },
    dividerFielderwork: {
      height: theme.spacing(4),
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2)
    },
    rightButton: {
      paddingRight: 0
    },
    leftButton: {
      paddingLeft: 0
    }
  })
)

export default useStyles
